<template>
  <div class="batch-export-status">
    <div v-if="batchItem?.status === 'succeeded'">
      <a
        class="status-badge"
        :class="[batchItem?.status, batchItem?.streamed ? 'streamed' : '']"
        :href="batchItem?.qboUrl"
        target="_blank"
      >
        <span>{{ batchItem?.statusText }}</span>
        <span class="ml-auto">
          <QbBallImg class="status-icon" />
        </span>
      </a>
    </div>
    <div v-else-if="batchItem?.status === 'failed'">
      <a
        class="status-badge"
        :class="[batchItem?.status, batchItem?.streamed ? 'streamed' : '']"
        href="#"
        @click.prevent="modalOpen = true"
      >
        <span>{{ batchItem?.statusText }}</span>
        <span class="ml-auto">
          <i class="status-icon" :class="[fontAwesomeIcon]"></i>
        </span>
      </a>
    </div>
    <div v-else>
      <div class="status-badge" :class="[batchItem?.status]">
        <span>{{ batchItem?.statusText }}</span>
        <span class="ml-auto">
          <i class="status-icon" :class="[fontAwesomeIcon]"></i>
        </span>
      </div>
    </div>
    <BatchItemSupportDetails
      :show="showSupportDetails"
      :batch-id="batchId"
      :batch-item-id="batchItemId"
    />
    <sera-modal
      :open="modalOpen"
      size="600"
      modalTitle="Error Detail"
      hideFooter
      @close="modalOpen = false"
    >
      <div class="qbo-error-detail">
        {{ batchItem?.errorText }}
      </div>
    </sera-modal>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

import BatchItemSupportDetails from "@/Reports/BatchItemSupportDetails.vue";
import store from "@/vuex/store";
import QbBallImg from "../Quickbooks/qb-logo-ball.svg?component";

const props = defineProps({
  dataPath: {
    type: String,
    default: null
  },
  batchId: {
    type: Number,
    default: null
  },
  batchItemId: {
    type: Number,
    default: null
  }
});

const modalOpen = ref(false);

const fontAwesomeIcon = computed(() => {
  if (batchItem.value?.status === "pending")
    return "far fa-circle-notch spinner";
  if (batchItem.value?.status === "failed") return "far fa-circle-exclamation";
  return "";
});

const showSupportDetails = computed(() => {
  return store.getters.internalUser;
});

const batch = computed(() => {
  {
    if (props.batchId in store.state.batches) {
      return store.state.batches[props.batchId];
    } else {
      return null;
    }
  }
});

const batchItem = computed(() => {
  {
    if (props.batchItemId in store.state.batchItems) {
      return store.state.batchItems[props.batchItemId];
    } else {
      return null;
    }
  }
});

onMounted(async () => {
  await refreshData();
});

async function refreshData() {
  await store.dispatch("fetchBatchItem", { url: props.dataPath });
}
</script>

<style lang="scss">
.batch-export-status {
  display: flex;
  align-items: center;
  gap: 5px;
}

.status-badge {
  width: 110px;
  padding: 2px 8px;
  font-weight: 600;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  gap: 5px;

  &.succeeded {
    color: var(--sera-color-accents-green-600);
    background-color: var(--sera-color-accents-green-100);
    &.streamed {
      animation: pulse-green 2s 1;
    }
  }
  &.pending {
    color: var(--sera-color-text-body);
    background-color: var(--sera-color-neutral-gray-light-gray-100);
  }
  &.failed {
    color: var(--sera-color-accents-red-600);
    background-color: var(--sera-color-accents-red-200);
    &.streamed {
      animation: pulse-red 2s 1;
    }
  }

  @keyframes pulse-red {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
    }
  }

  @keyframes pulse-green {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
    }
  }
}

.status-icon {
  height: 16px;
  width: 16px;
  font-size: 16px;
}

.qbo-error-detail {
  padding: 1rem;
  color: var(--sera-color-accents-red-600);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.5;
}
</style>
